import {
  APPEND_ALBUM_DATA,
  CHANGE_CONTENT_VISIBILITY,
  CLOSE_SHARE_MODAL,
  REMOVE_MEDIA_FROM_ALBUM,
  SET_ALBUM_DATA,
  SET_ANIMAL_FILTER,
  SET_FILTER_OPTIONS,
  SET_HABITAT,
  SET_PAGE,
  SET_QUERY_URL,
  SET_SHARE_MODAL_DATA,
  SET_TYPE,
  SET_ZOO_FILTER,
  TOGGLE_ANIMAL_FILTER,
  TOGGLE_ZOO_FILTER,
  UPDATE_ALBUM_DATA,
} from './types';

const initialState = {
  availableZoos: [],
  availableZooIds: [],
  availableAnimals: [],
  availableAnimalIds: [],
  habitatSlug: null,
  zooSlug: null,
  queryURL: null,
  type: 'clips',
  album: {
    total: null,
    list: [],
    page: 1,
  },
  filters: {
    showAnimalFilter: true,
    habitatIds: [],
    showZooFilter: true,
    zooIds: [],
  },
  shareModal: {
    open: false,
    mediaId: null,
    nextId: null,
    prevId: null,
    data: {},
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FILTER_OPTIONS: {
      const { animals, habitatIds, zoos, zooIds } = payload;
      return {
        ...state,
        availableAnimals: animals,
        availableAnimalIds: habitatIds,
        availableZoos: zoos,
        availableZooIds: zooIds,
      };
    }
    case SET_QUERY_URL: {
      const { queryURL } = payload;
      return { ...state, queryURL };
    }
    case TOGGLE_ANIMAL_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showAnimalFilter: !state.filters.showAnimalFilter,
        },
      };
    }
    case TOGGLE_ZOO_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          showZooFilter: !state.filters.showZooFilter,
        },
      };
    }
    case SET_ZOO_FILTER: {
      const { zooIds } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          zooIds,
        },
      };
    }
    case SET_ANIMAL_FILTER: {
      const { habitatIds } = payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          habitatIds,
        },
      };
    }
    case SET_ALBUM_DATA: {
      const { data } = payload;

      return { ...state, album: { page: 1, ...data } };
    }
    case SET_TYPE: {
      const { type } = payload;
      return { ...state, type, album: { ...state.album, page: 1 } };
    }

    case SET_PAGE: {
      const { page } = payload;
      return { ...state, album: { ...state.album, page } };
    }
    case APPEND_ALBUM_DATA: {
      const { data } = payload;

      return {
        ...state,
        album: {
          page: state.album.page + 1,
          total: data.total,
          list: [...state.album.list, ...data.list],
        },
      };
    }
    case CHANGE_CONTENT_VISIBILITY: {
      const { mediaId, action } = payload;
      const disabled = action === 'hide';
      return {
        ...state,
        album: {
          ...state.album,
          list: state?.album?.list?.map((media) => (media._id === mediaId ? { ...media, disabled } : media)),
        },
      };
    }
    case UPDATE_ALBUM_DATA: {
      const { id, data } = payload;
      return {
        ...state,
        album: {
          list: state.album.list.map((media) => (media._id === id ? { ...media, ...data } : media)),
        },
      };
    }
    case REMOVE_MEDIA_FROM_ALBUM: {
      const { id } = payload;
      return {
        ...state,
        album: {
          list: state.album.list.filter((media) => media._id !== id),
        },
      };
    }
    case SET_SHARE_MODAL_DATA: {
      const { mediaId, nextId, prevId, data } = payload;

      return {
        ...state,
        shareModal: {
          open: true,
          mediaId,
          nextId,
          prevId,
          data,
        },
      };
    }

    case CLOSE_SHARE_MODAL: {
      return {
        ...state,
        shareModal: {
          open: false,
          mediaId: null,
          nextId: null,
          prevId: null,
          data: {},
        },
      };
    }

    case SET_HABITAT: {
      const { habitat } = payload;
      return {
        ...state,
        ...habitat,
      };
    }

    default: {
      return state;
    }
  }
};
